import { NgModule, CUSTOM_ELEMENTS_SCHEMA } from '@angular/core';
import { RouterModule } from '@angular/router';

import { MarketmanagerSharedModule } from '../../shared';
import {
    AdditionalflatService,
    AdditionalflatPopupService,
    AdditionalflatComponent,
    AdditionalflatDetailComponent,
    AdditionalflatDialogComponent,
    AdditionalflatPopupComponent,
    AdditionalflatDeletePopupComponent,
    AdditionalflatDeleteDialogComponent,
    additionalflatRoute,
    additionalflatPopupRoute,
    AdditionalflatResolvePagingParams,
} from './';

const ENTITY_STATES = [
    ...additionalflatRoute,
    ...additionalflatPopupRoute,
];

@NgModule({
    imports: [
        MarketmanagerSharedModule,
        RouterModule.forRoot(ENTITY_STATES, { useHash: true })
    ],
    declarations: [
        AdditionalflatComponent,
        AdditionalflatDetailComponent,
        AdditionalflatDialogComponent,
        AdditionalflatDeleteDialogComponent,
        AdditionalflatPopupComponent,
        AdditionalflatDeletePopupComponent,
    ],
    entryComponents: [
        AdditionalflatComponent,
        AdditionalflatDialogComponent,
        AdditionalflatPopupComponent,
        AdditionalflatDeleteDialogComponent,
        AdditionalflatDeletePopupComponent,
    ],
    providers: [
        AdditionalflatService,
        AdditionalflatPopupService,
        AdditionalflatResolvePagingParams,
    ],
    schemas: [CUSTOM_ELEMENTS_SCHEMA]
})
export class MarketmanagerAdditionalflatModule {}



// WEBPACK FOOTER //
// ./src/main/webapp/app/entities/additionalflat/additionalflat.module.ts